import {fileTypeEnum} from "../../serverClientShared/sharedEnums";
import ConditionalComponent from "./ConditionalComponent";
import Badge from "@mui/material/Badge";
import ImageIcon from "@mui/icons-material/Image";
import MovieIcon from "@mui/icons-material/Movie";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import React from "react";
import PropTypes from "prop-types";
import {useStores} from "../../Hooks";
import {getNodeMedia} from "../../serverClientShared/sharedUtils";

const FilesIndicators = (props => {
    const {procedureStore} = useStores();
    const {isPreview} = props;
    const currentNode = (isPreview
            ? procedureStore.currentPreviewedNode
            : procedureStore.currentNode
    ) || {};
    const currentProcedure = procedureStore.currentProcedure;
    const imagesCount = getNodeMedia(currentNode, "NodeMediaFilesRefs", currentProcedure).FileRefs.filter(file => file.FileType === fileTypeEnum.IMAGE).length;
    const videoCount = getNodeMedia(currentNode, "NodeMediaFilesRefs", currentProcedure).FileRefs.filter(file => file.FileType === fileTypeEnum.VIDEO).length;
    const pdfCount = getNodeMedia(currentNode, "NodeMediaFilesRefs", currentProcedure).FileRefs.filter(file => file.FileType === fileTypeEnum.PDF).length;
    return (
        <div className='files-indicator'>
            <ConditionalComponent if={!!imagesCount}>
                <Badge
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: "center",
                    }}
                    badgeContent={imagesCount}
                    color="error"
                >
                    <ImageIcon fontSize='default'/>
                </Badge>
            </ConditionalComponent>
            <ConditionalComponent if={!!videoCount}>
                <Badge
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: "center",
                    }}
                    badgeContent={videoCount}
                    color="error"
                >
                    <MovieIcon fontSize='default'/>
                </Badge>
            </ConditionalComponent>
            <ConditionalComponent if={!!pdfCount}>
                <Badge
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: "center",
                    }}
                    badgeContent={pdfCount}
                    color="error"
                >
                    <PictureAsPdfIcon fontSize='default'/>
                </Badge>

            </ConditionalComponent>
        </div>
    );
});

FilesIndicators.propTypes = {
    isPreview: PropTypes.bool.isRequired
}

export default FilesIndicators;
